import { Component } from '@angular/core';
import { BackwardComponent } from '../backward/backward.component';
import { IQuestionEventsService, QUESTION_EVENTS_SERVICE_TOKEN } from '../../../../services/IQuestionEvents';
import { Inject } from '@angular/core';

@Component({
  selector: 'forward',
  template: '',
  styleUrls: [],
  standalone: false
})
export class ForwardComponent extends BackwardComponent {

  public override click(): void {
    this.questionEventsService.controlClicked.next(true);
    this.onChange.next(1);
  }

}
